<template>
  <div class="customize_form_wrapper">
    <a-form-model
      v-if="isShowForm"
      :model="form"
      ref="form"
      inline
      :disabled="disabled"
    >
      <a-row :gutter="40">
        <template v-for="(item, index) in schema">
          <a-col
            v-if="item.type !== 'textarea'"
            :key="index"
            :xl="8"
            :lg="12"
            :md="24"
            :sm="24"
            :xs="24"
          >
            <a-form-model-item
              :style="item.style"
              :label="item.label"
              :rules="item.rules || []"
              :prop="item.key"
            >
              <a-input
                v-if="item.type === 'input'"
                v-model="form[item.key]"
                @input="val => item.input && item.input(val, form)"
                :disabled="item.disabled"
                :placeholder="item.placeholder"
              />
              <a-select
                show-search
                option-filter-prop="children"
                v-else-if="item.type === 'select'"
                v-model="form[item.key]"
                :placeholder="item.placeholder"
                @change="val => item.change && item.change(val, form)"
                :disabled="item.disabled"
              >
                <a-select-option
                  v-for="selectOption in item.selectList"
                  :value="selectOption.id"
                  :key="selectOption.id"
                  :label="selectOption.name"
                >
                  {{ selectOption.name }}
                </a-select-option>
              </a-select>
              <a-date-picker
                style="width:100%;"
                format="YYYY--MM-DD"
                valueFormat="YYYY--MM-DD"
                v-else-if="item.type === 'date'"
                v-model="form[item.key]"
              />
              <a-checkbox
                v-else-if="item.type === 'checkbox'"
                v-model="form[item.key]"
              />
            </a-form-model-item>
          </a-col>
          <a-col v-else :span="24" :key="index">
            <a-form-model-item
              :label="item.label"
              :rules="item.rules || []"
              :prop="item.key"
              class="plass"
              style="width: 100%; color: #000"
            >
              <a-input
                v-if="item.type === 'textarea'"
                type="textarea"
                :rows="3"
                v-model="form[item.key]"
                :placeholder="item.placeholder"
                :readonly="item.readOnly"
                :show-word-limit="item.limit"
                :disabled="item.disabled"
              />
            </a-form-model-item>
          </a-col>
        </template>
      </a-row>
      <slot></slot>
    </a-form-model>
    <a-row v-else>
      <template v-for="(item, index) in schema">
        <a-col :key="index" :xl="8" :lg="12" :md="24" :sm="24" :xs="24">
          <div class="detail_item">
            <span class="label">{{ item.label }}：</span>
            <span
              class="value no-wrap"
              :title="
                Object.prototype.hasOwnProperty.call(model, item.key + 'Str')
                  ? model[item.key + 'Str']
                  : model[item.key]
              "
            >
              {{
                Object.prototype.hasOwnProperty.call(model, item.key + 'Str')
                  ? model[item.key + 'Str']
                  : model[item.key]
              }}
            </span>
          </div>
        </a-col>
      </template>
    </a-row>
    <a-row>
      <slot name="uploadSlot"></slot>
    </a-row>
    <a-row>
      <slot span="6" name="fileListSlot"></slot>
    </a-row>
    <a-row>
      <slot name="vagueSearch"></slot>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'customize-form',
  data() {
    return {
      form: {},
      date: null,
    }
  },
  watch: {
    schema: {
      deep: true,
      immediate: true,
      handler(newValue) {
        newValue.forEach(item => {
          const key = item.key
          // 这个判断主要处理，如果 model 比 schema 处理的早，schema 的 value 值就会覆盖 model的值
          if (!this.form[key]) {
            this.$set(this.form, key, item.value || '')
          }
        })
      },
    },
    model: {
      deep: true,
      immediate: false,
      handler(newValue) {
        if (this.isShowForm) {
          this.setForm(newValue)
        }
      },
    },
    isShowForm: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.setForm(this.model)
        }
      },
    },
  },
  props: {
    // 表单或者详情的数据结构模型
    schema: {
      type: Array,
      default: () => [],
    },
    // 是否显示表单
    isShowForm: {
      type: Boolean,
      default: true,
    },
    // 数据
    model: {
      type: Object,
      default: () => {},
    },
    // 是否显示骨架屏
    isLoading: {
      type: Boolean,
      default: false,
    },
    // 页面是否是全屏（客户信息里边需要减去左边菜单的宽度做自适应）true: 是 false：不是
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getFormData() {
      return { ...this.form }
    },
    reset(key) {
      if (key) {
        this.$refs.form.resetFields(key)
        return
      }
      this.$refs.form.resetFields()
    },
    async validateFields() {
      return await this.$refs.form.validate()
    },
    setForm(data) {
      Object.keys(data).forEach(key => {
        this.$set(this.form, key, data[key])
      })
    },
  },
}
</script>

<style scoped lang="less">
.a-select,
.a-input {
  width: 100%;
}
.a-textarea {
  width: 100%;
}
.a-form-model-item {
  width: 100%;
  text-align: left;
}
/deep/.a-textarea.is-disabled .a-textarea__inner {
  color: #000 !important;
}
.detail_item {
  font-size: 14px;
  color: #000;
  line-height: 30px;
  font-weight: 400;
  margin-bottom: 10px;
  .label {
    display: inline-block;
    font-size: 14px;
    color: #000;
    line-height: 30px;
  }
  .value {
    font-size: 14px;
    color: #3a3f63;
    display: inline-block;
  }
  .no-wrap {
    max-width: 260px;
    vertical-align: bottom;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.m_p {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  .m_key {
    font-size: 14px;
    margin-right: 14px;
  }
  .m_value {
    font-size: 14px;
  }
}
</style>
